import React from "react";
import { NavLink } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Col,
  Container,
  Nav,
  Navbar,
  Row,
  ListGroup,
} from "react-bootstrap";
import { useLanguage, useToggle } from "hooks";
import { switchLanguage } from "store/app";
import { Icons } from "components";
import Login from "./Login";

export default function Header() {
  const language = useLanguage(); //language returned from useLanguage hook; it’s an object with current language key --> "value in current language";
  const { isLoggedIn } = useSelector((state) => state.auth); // call data from auth store
  const dispatch = useDispatch();
  const [mobileMenuOpen, toggleMobileMenuOpen] = useToggle();
  const headerRef = React.useRef(null);
  const mobileLogoRef = React.useRef(null);

  const changeLanguage = () => {
    if (language.lang === "ar") {
      return dispatch(switchLanguage("en"));
    }
    dispatch(switchLanguage("ar"));
  };

  function scrollFunction() {
    if (
      document.documentElement.scrollTop >
        document.getElementById("header").offsetHeight ||
      document.documentElement.scrollTop > 40
    ) {
      headerRef.current.style.backgroundColor = "#fff";
      headerRef.current.style.borderBottom = "1px solid #f2f2f5";
      mobileLogoRef.current.style.display = "none";
    } else {
      headerRef.current.style.border = "none";
      headerRef.current.style.backgroundColor = "transparent";
      mobileLogoRef.current.style.display = "flex";
    }
  }

  React.useLayoutEffect(() => {
    window.addEventListener("scroll", scrollFunction);
    return () => window.removeEventListener("scroll", scrollFunction);
  }, []);

  React.useEffect(() => {
    window.onclick = function (event) {
      if (
        !event.target.matches(".mobileNav") &&
        !event.target.matches(".menu") &&
        mobileMenuOpen
      ) {
        toggleMobileMenuOpen();
      }
    };
  });

  return (
    <header
      ref={headerRef}
      id="header"
      className="position-fixed fixed-top w-100"
    >
      <Container>
        <Row className="align-items-center py-2">
          <Col
            xs={12}
            className="p-lg-0 d-flex d-lg-none justify-content-center align-items-center"
          >
            <NavLink to="/">
              <img ref={mobileLogoRef} src={"/images/logo.svg"} alt="" />
            </NavLink>
          </Col>
          <Col xl={3} lg={1} md={7} sm={isLoggedIn ? 7 : 8} xs={5}>
            <Row className="align-items-center h-100">
              <Col xl={6} md={3} sm={2} xs={2} className="d-lg-none d-xs-block">
                <img
                  role="button"
                  src={"/images/menu.png"}
                  alt=""
                  className="menu"
                  onClick={toggleMobileMenuOpen}
                />
              </Col>
              <Col
                xl={3}
                lg={12}
                md={10}
                sm={10}
                xs={10}
                className="p-lg-0 d-none d-lg-flex align-items-center gap-2 d-none d-lg-block"
              >
                <NavLink to="/" onClick={() => window.scrollTo(0, 0)}>
                  <img src={"/images/logo.svg"} alt="" className="logo" />
                </NavLink>
              </Col>
              <Col xl={6} className="px-0 ipa_library_logo d-none d-xl-block">
                <NavLink to="/" onClick={() => window.scrollTo(0, 0)}>
                  <h1 className="logo-text fw-bold text-blue me-2 mb-0">
                    {language.ipaSchoolLibrary}
                  </h1>
                </NavLink>
              </Col>
            </Row>
          </Col>
          <Col xl={6} lg={7} md={0} sm={0} xs={0} className="d-none d-lg-block">
            <Navbar expand="lg" className="p-0">
              <Navbar.Collapse
                className={`${!mobileMenuOpen && "show"} p-0`}
                id="basic-navbar-nav"
              >
                <Nav>
                  <Nav.Link as={NavLink} to="/">
                    {language.home}
                  </Nav.Link>
                  <Nav.Link as={NavLink} to="/books">
                    {language.books}
                  </Nav.Link>
                  <Nav.Link as={NavLink} to="/magazines/">
                    {language.magazines}
                  </Nav.Link>
                  <Nav.Link as={NavLink} to="/multimedia">
                    {language.multimedia}
                  </Nav.Link>
                  <Nav.Link as={NavLink} to="/contact">
                    {language.contactUs}
                  </Nav.Link>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </Col>
          <Col xl={3} lg={4} md={5} sm={isLoggedIn ? 5 : 4} xs={7} className="">
            <Row className="align-items-center gx-2 justify-content-between">
              <Col
                xl={isLoggedIn ? 4 : 6}
                lg={isLoggedIn ? 4 : 8}
                md={isLoggedIn ? 4 : 6}
                sm={isLoggedIn ? 4 : 7}
                xs={6}
                className="text-start p-0"
              >
                <div
                  role="button"
                  onClick={changeLanguage}
                  className={`d-flex align-items-center justify-content-center gap-1`}
                >
                  <Icons.Language className="d-none d-md-block" />
                  <p className="fw-normal text-light4">
                    {language.lang === "ar" ? "English" : "العربيه"}
                  </p>
                </div>
              </Col>
              <Col
                xl={isLoggedIn ? 6 : 6}
                lg={isLoggedIn ? 6 : 4}
                md={isLoggedIn ? 6 : 6}
                sm={isLoggedIn ? 6 : 5}
                xs={6}
                className="text-start"
              >
                <Login />
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <Container>
        <div
          className={`position-absolute mobileNav d-block d-lg-none ${
            mobileMenuOpen && "open"
          }`}
        >
          <ListGroup>
            <ListGroup.Item as={NavLink} to="/">
              {language.home}
            </ListGroup.Item>
            <ListGroup.Item as={NavLink} to="/books">
              {language.books}
            </ListGroup.Item>
            <ListGroup.Item as={NavLink} to="/magazines/">
              {language.magazines}
            </ListGroup.Item>
            <ListGroup.Item as={NavLink} to="/multimedia">
              {language.multimedia}
            </ListGroup.Item>
            <ListGroup.Item as={NavLink} to="/contact">
              {language.contactUs}
            </ListGroup.Item>
          </ListGroup>
        </div>
      </Container>
    </header>
  );
}
